// add a comment here
export default {
  defaultTitle: 'Make Life-Changing Money Teaching What You Know',
  description:
    'Research, design, produce, and deliver high-quality courses that sell.',
  author: 'badass_courses',
  favicon: '/favicon.ico',
  email: 'team@badass.dev',
  siteUrl: 'badass.dev',
  additionalMetaTags: [
    {property: 'author', content: 'Joel Hooks'},
    {
      property: 'keywords',
      content: '',
    },
  ],
  twitter: {
    cardType: 'summary_large_image',
    handle: '@badass_courses',
    site: '@badass_courses',
  },
  openGraph: {
    type: 'website',
    site_name: 'Badass Courses',
    profile: {
      firstName: 'Joel',
      lastName: 'Hooks',
    },
    images: [
      {
        url: 'https://res.cloudinary.com/badass-courses/image/upload/v1692950786/badass-share_card-3_2x_gvwwvm.jpg',
        width: 1200,
        height: 628,
      },
    ],
  },
}
